import React from "react";
import "./blogs.css";
import vastuBanner from "../../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../../components/BlogSlider.js";
import ServiceProduts from "../../components/ServiceProduts.js";

const CareerAstrologyBlog = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


        <h2>Career Astrology: Guiding Stars for Your Professional Path</h2>

      <p>Career astrology is one of the most sought-after fields in Vedic astrology. It helps individuals uncover their true potential and guides them toward fulfilling careers by analyzing their natal charts.</p>

      <p>The 10th house in astrology, often referred to as the ‘Karma Bhava’, is the key house that governs profession, achievements, fame, and public image. The planets situated in or aspecting this house influence a person’s career direction.</p>

      <p>Jupiter, Sun, Mars, and Mercury play significant roles in professional success. A strong Sun denotes leadership, Mars represents energy and technical skills, Mercury boosts communication and intellect, and Jupiter offers wisdom and teaching ability.</p>

      <p>In career astrology, planetary dasha (timelines) also determine periods of growth, change, or challenges. Astrologers suggest career shifts, job changes, or entrepreneurial ventures based on these cycles.</p>

      <h2>Career Guidance Based on Birth Chart</h2>

      <p>The position of the Moon reflects mental orientation, while the Ascendant or Lagna determines personality traits. Together, they help in understanding the kind of work environment or role an individual may thrive in.</p>

      <p>For example, someone with a strong Mercury in the 10th house may find success in writing, communication, or marketing, while Mars may lead to success in engineering, defense, or sports fields.</p>

      <p>Career astrology offers insights for students selecting a stream, professionals facing stagnation, or entrepreneurs seeking direction.</p>

    
    <p>Apart from the celestial aspects regarding wealth and astrology, in Bhagwad Gita, Chapter 2, Verse 47, Lord Krishna tells Arjuna about the relevance of Karma as follows-</p>
        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src={vastuBanner} alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <div className="contact-form">
          <h3>Contact Us</h3>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="tel" placeholder="Phone No" required />
            <select required>
              <option value="">Select Service</option>
              <option value="vastu">Astro Vastu Consultation</option>
              <option value="gemstone">Gemstone Suggestion</option>
              <option value="puja">Puja or Remedy Guidance</option>
            </select>
            <textarea placeholder="Please Write Any Note Here..." required />
            <button type="submit">Submit</button>
          </form>
        </div>

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default CareerAstrologyBlog;
